import React, {Fragment} from 'react';
import {withRouter} from 'react-router-dom';
import Countdown from 'react-countdown';
import {CircleArrow as ScrollUpButton} from "react-scroll-up-button";
import AnchorLink from 'react-anchor-link-smooth-scroll'
import previewImageMain from '../../images/common/1.png'
import previewImageArt from '../../images/common/3.png'
import previewImageTI from '../../images/common/2.png'


import './LayoutMain.scss';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';

import GetIcon from '../GetIcon/GetIcon';

class LayoutMain extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileMenu: false,
    };
  }

  clickSpoilerHandler = (e) => {
    e.target.classList.toggle('_active');
    e.target.nextSibling.classList.toggle('_active');
  }

  renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
      // Render a complete state
      return (
        <div className="timer-container">
          <p>Winners Announcement in...</p>

          <div className="timer-inner">
            <div className="timer-block">
              <div className="timer-value">{days}</div>
              <div className="timer-text">Day</div>
            </div>

            <div className="timer-block">
              <div className="timer-value">:</div>
            </div>

            <div className="timer-block">
              <div className="timer-value">{hours}</div>
              <div className="timer-text">Hours</div>
            </div>

            <div className="timer-block">
              <div className="timer-value">:</div>
            </div>
            
            <div className="timer-block">
              <div className="timer-value">{minutes}</div>
              <div className="timer-text">Mins</div>
            </div>

            <div className="timer-block">
              <div className="timer-value">:</div>
            </div>
            
            <div className="timer-block">
              <div className="timer-value">{seconds}</div>
              <div className="timer-text">Secs</div>
            </div>
          </div>
        </div>
      );
    } else {
      // Render a countdown
      return (
        <div className="timer-container">
          <p>Winners Announcement in...</p>

          <div className="timer-inner">
            <div className="timer-block">
              <div className="timer-value">{days}</div>
              <div className="timer-text">Day</div>
            </div>

            <div className="timer-block">
              <div className="timer-value">:</div>
            </div>

            <div className="timer-block">
              <div className="timer-value">{hours}</div>
              <div className="timer-text">Hours</div>
            </div>

            <div className="timer-block">
              <div className="timer-value">:</div>
            </div>
            
            <div className="timer-block">
              <div className="timer-value">{minutes}</div>
              <div className="timer-text">Mins</div>
            </div>

            <div className="timer-block">
              <div className="timer-value">:</div>
            </div>
            
            <div className="timer-block">
              <div className="timer-value">{seconds}</div>
              <div className="timer-text">Secs</div>
            </div>
          </div>
        </div>
      );
    }
  };

  render() {

    return (
        <Fragment>
         <Header />
          <main className="main">
            <section id="intro" className="intro">
              <div className="container-wrapper--grey900">
                <div className="content-container content-container--intro">
                  <div className="intro-inner">
                    <GetIcon name="powered-by-unigine-community-text-colored"/>
                  
                    <div className="column-left">
                      <div className="intro-text-block">
                        <div className="january-date-text-mobile">
                          <GetIcon name="january-date-text"/>
                        </div>
                        <svg className="icon black-box-colored" width="518" height="498" viewBox="0 0 518 498" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M518 298.743L345.359 398.35V199.135L518 99.5263V298.743Z" fill="#545B63"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M172.716 99.5263L345.357 199.217V398.433L172.716 298.743V99.5263Z" fill="#10151C"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M185.796 113.718C189.84 116.054 193.119 121.731 193.119 126.399C193.119 131.066 189.84 132.957 185.796 130.621C181.749 128.286 178.471 122.609 178.471 117.941C178.471 113.273 181.749 111.383 185.796 113.718ZM332.28 367.337C336.323 369.672 339.605 375.35 339.605 380.018C339.605 384.685 336.323 386.576 332.28 384.24C328.234 381.903 324.953 376.226 324.953 371.56C324.955 366.892 328.234 365.002 332.28 367.337ZM302.982 350.42C307.026 352.756 310.307 358.433 310.307 363.101C310.307 367.768 307.026 369.659 302.982 367.323C298.937 364.986 295.657 359.309 295.657 354.643C295.658 349.975 298.937 348.085 302.982 350.42ZM273.685 333.503C277.73 335.838 281.01 341.516 281.01 346.184C281.01 350.851 277.73 352.742 273.685 350.406C269.641 348.071 266.36 342.392 266.36 337.726C266.362 333.058 269.641 331.168 273.685 333.503ZM244.389 316.586C248.435 318.921 251.712 324.599 251.712 329.267C251.712 333.934 248.435 335.825 244.389 333.489C240.344 331.152 237.062 325.475 237.062 320.807C237.062 316.141 240.344 314.251 244.389 316.586ZM215.092 299.669C219.137 302.005 222.416 307.682 222.416 312.35C222.416 317.017 219.137 318.908 215.092 316.572C211.046 314.235 207.766 308.559 207.766 303.89C207.766 299.224 211.046 297.334 215.092 299.669ZM185.796 282.752C189.84 285.087 193.119 290.765 193.119 295.433C193.119 300.1 189.84 301.991 185.796 299.655C181.749 297.318 178.471 291.642 178.471 286.973C178.471 282.307 181.749 280.416 185.796 282.752ZM332.28 333.531C336.323 335.867 339.605 341.544 339.605 346.213C339.605 350.879 336.323 352.77 332.28 350.434C328.234 348.099 324.953 342.421 324.953 337.754C324.955 333.084 328.234 331.195 332.28 333.531ZM302.982 316.614C307.026 318.95 310.307 324.627 310.307 329.296C310.307 333.962 307.026 335.853 302.982 333.517C298.937 331.181 295.657 325.504 295.657 320.837C295.658 316.167 298.937 314.278 302.982 316.614ZM273.685 299.695C277.73 302.032 281.01 307.709 281.01 312.377C281.01 317.044 277.73 318.935 273.685 316.598C269.641 314.262 266.36 308.585 266.36 303.919C266.362 299.25 269.641 297.361 273.685 299.695ZM244.389 282.779C248.435 285.113 251.712 290.792 251.712 295.46C251.712 300.127 248.435 302.018 244.389 299.681C240.344 297.347 237.062 291.668 237.062 287.002C237.062 282.333 240.344 280.444 244.389 282.779ZM215.092 265.862C219.137 268.196 222.416 273.875 222.416 278.543C222.416 283.21 219.137 285.101 215.092 282.764C211.046 280.428 207.766 274.751 207.766 270.085C207.766 265.416 211.046 263.527 215.092 265.862ZM185.796 248.945C189.84 251.279 193.119 256.958 193.119 261.626C193.119 266.293 189.84 268.184 185.796 265.847C181.749 263.511 178.471 257.834 178.471 253.168C178.471 248.499 181.749 246.61 185.796 248.945ZM332.28 299.724C336.323 302.06 339.605 307.737 339.605 312.405C339.605 317.072 336.323 318.963 332.28 316.627C328.234 314.292 324.953 308.613 324.953 303.947C324.955 299.279 328.234 297.389 332.28 299.724ZM302.982 282.807C307.026 285.143 310.307 290.82 310.307 295.488C310.307 300.155 307.026 302.046 302.982 299.71C298.937 297.375 295.657 291.696 295.657 287.03C295.658 282.362 298.937 280.472 302.982 282.807ZM273.685 265.89C277.73 268.226 281.01 273.903 281.01 278.571C281.01 283.238 277.73 285.129 273.685 282.793C269.641 280.456 266.36 274.779 266.36 270.113C266.362 265.445 269.641 263.555 273.685 265.89ZM244.389 248.973C248.435 251.309 251.712 256.986 251.712 261.654C251.712 266.321 248.435 268.212 244.389 265.876C240.344 263.539 237.062 257.862 237.062 253.196C237.062 248.528 240.344 246.636 244.389 248.973ZM215.092 232.056C219.137 234.392 222.416 240.069 222.416 244.737C222.416 249.404 219.137 251.295 215.092 248.959C211.046 246.622 207.766 240.945 207.766 236.277C207.766 231.609 211.046 229.719 215.092 232.056ZM185.796 215.139C189.84 217.475 193.119 223.152 193.119 227.82C193.119 232.487 189.84 234.378 185.796 232.042C181.749 229.705 178.471 224.03 178.471 219.36C178.471 214.694 181.749 212.802 185.796 215.139ZM332.28 265.918C336.323 268.254 339.605 273.933 339.605 278.599C339.605 283.266 336.323 285.157 332.28 282.821C328.234 280.486 324.953 274.807 324.953 270.141C324.955 265.471 328.234 263.581 332.28 265.918ZM302.982 249.001C307.026 251.337 310.307 257.016 310.307 261.682C310.307 266.349 307.026 268.24 302.982 265.904C298.937 263.569 295.657 257.89 295.657 253.224C295.658 248.554 298.937 246.664 302.982 249.001ZM273.685 232.084C277.73 234.42 281.01 240.097 281.01 244.765C281.01 249.432 277.73 251.323 273.685 248.987C269.641 246.652 266.36 240.973 266.36 236.307C266.362 231.637 269.641 229.747 273.685 232.084ZM244.389 215.165C248.435 217.502 251.712 223.179 251.712 227.847C251.712 232.513 248.435 234.405 244.389 232.068C240.344 229.733 237.062 224.056 237.062 219.388C237.062 214.72 240.344 212.83 244.389 215.165ZM215.092 198.248C219.137 200.585 222.416 206.262 222.416 210.93C222.416 215.596 219.137 217.488 215.092 215.153C211.046 212.816 207.766 207.139 207.766 202.471C207.766 197.803 211.046 195.913 215.092 198.248ZM185.796 181.331C189.84 183.668 193.119 189.345 193.119 194.013C193.119 198.681 189.84 200.571 185.796 198.234C181.749 195.898 178.471 190.221 178.471 185.553C178.471 180.885 181.749 178.996 185.796 181.331ZM332.28 232.112C336.323 234.448 339.605 240.125 339.605 244.793C339.605 249.46 336.323 251.351 332.28 249.015C328.234 246.68 324.953 241.003 324.953 236.335C324.953 231.667 328.234 229.776 332.28 232.112ZM302.982 215.195C307.026 217.531 310.307 223.208 310.307 227.876C310.307 232.543 307.026 234.434 302.982 232.098C298.937 229.763 295.657 224.086 295.657 219.418C295.658 214.748 298.937 212.859 302.982 215.195ZM273.685 198.276C277.73 200.613 281.01 206.29 281.01 210.958C281.01 215.624 277.73 217.516 273.685 215.181C269.641 212.846 266.36 207.167 266.36 202.499C266.362 197.831 269.641 195.942 273.685 198.276ZM244.389 181.359C248.435 183.696 251.712 189.373 251.712 194.041C251.712 198.709 248.435 200.599 244.389 198.262C240.344 195.927 237.062 190.25 237.062 185.582C237.062 180.914 240.344 179.025 244.389 181.359ZM215.092 164.442C219.137 166.779 222.416 172.456 222.416 177.124C222.416 181.79 219.137 183.682 215.092 181.345C211.046 179.011 207.766 173.334 207.766 168.665C207.766 163.997 211.046 162.108 215.092 164.442ZM185.796 147.525C189.84 149.862 193.119 155.539 193.119 160.207C193.119 164.873 189.84 166.765 185.796 164.43C181.749 162.094 178.471 156.417 178.471 151.748C178.471 147.08 181.749 145.191 185.796 147.525ZM332.28 198.304C336.323 200.641 339.605 206.318 339.605 210.986C339.605 215.654 336.323 217.544 332.28 215.209C328.234 212.873 324.953 207.196 324.953 202.527C324.953 197.859 328.234 195.968 332.28 198.304ZM302.982 181.388C307.026 183.724 310.307 189.401 310.307 194.069C310.307 198.737 307.026 200.627 302.982 198.292C298.937 195.957 295.657 190.279 295.657 185.611C295.657 180.942 298.937 179.051 302.982 181.388ZM273.685 164.471C277.73 166.807 281.01 172.484 281.01 177.152C281.01 181.82 277.73 183.71 273.685 181.375C269.641 179.04 266.36 173.362 266.36 168.694C266.36 164.025 269.641 162.134 273.685 164.471ZM244.389 147.554C248.435 149.89 251.712 155.567 251.712 160.235C251.712 164.903 248.435 166.793 244.389 164.458C240.344 162.122 237.062 156.445 237.062 151.777C237.062 147.108 240.344 145.217 244.389 147.554ZM215.092 130.637C219.137 132.973 222.416 138.65 222.416 143.318C222.416 147.986 219.137 149.876 215.092 147.539C211.046 145.205 207.766 139.528 207.766 134.86C207.766 130.19 211.046 128.3 215.092 130.637Z" fill="#10151C"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M345.357 199.217L172.716 99.6075L345.357 0L518 99.6075L345.357 199.217Z" fill="#2A323B"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M345.357 199.217L172.716 99.6075L345.357 0V196V199.217Z" fill="#545B63"/>
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 398.392L172.716 298.826L345.357 398.433L172.646 498L0 398.392Z" fill="url(#paint0_linear)"/>
                          <defs>
                          <linearGradient id="paint0_linear" x1="279" y1="274" x2="102" y2="444.5" gradientUnits="userSpaceOnUse">
                          <stop stop-color="#2A323B"/>
                          <stop offset="1" stop-color="#2A323B" stop-opacity="0"/>
                          </linearGradient>
                          </defs>
                          </svg>

                        <GetIcon name="circles-4-colored"/>
                        <GetIcon name="hackathon-2-unigine-text-colored"/>
                      </div>
                    </div>

                    <div className="column-right">
                      <GetIcon name="january-date-text"/>

                      <div className="hackathon-2-unigine-mobile">
                        <GetIcon name="hackathon-2-unigine-text-colored"/>
                      </div>

                      <p className="intro-text">The Second UNIGINE COMMUNITY <span>ONLINE</span> HACKATHON</p>
                      
                      <p className="intro-text intro-text-small">Subscribe to UNIGINE updates so you don't miss the next one!</p>

                      <a href="https://unigine.com/?sign-up-for-news=true#news" className="button button--purple">subscribe</a>

                    </div>

                    <div className="column-center">
                      <p className="intro-text-theme">Hackathon Theme:</p>
                      <GetIcon name="black-box-text-colored"/>
                    </div>

                    <AnchorLink href="#winners" offset='60' className="button-down"></AnchorLink>
                  </div>
                </div>
              </div>
            </section>

            <section id="winners" className="winners">
              <div className="content-container content-container--winners">
                <h2 className="subtitle subtitle--center">Winners</h2>

                <ul className="winner-list">
                  <li className="winner-item">
                    <div className="winner-description winner-description-main">
                      <div className="winner-title-wrapper">
                        <div className="winner-icons"><GetIcon name="icon-main-winner-colored"/><GetIcon name="icon-idea-colored"/></div>
                        <h3>Main Winner</h3>
                        <span className="winner-nomination">and winner in the nomination</span>
                        <h3>Idea &amp; Narrative</h3>
                      </div>

                      <p className="winner-project">XtremeZero team with project CrashCourseThunderTrigger</p>

                      <p className="winner-names">XtremeZero</p>
                    </div>
                    <div className="winner-image-container">

                      <img className="winner-image" src={previewImageMain}></img>
                    </div>
                  </li>

                  <li className="winner-item">

                    <div className="winner-description winner-description-TI">
                      <span className="mobile-none">winner in the nominations</span>

                      <div className="winner-title-wrapper">
                        <div className="winner-icons winner-icons-mt"><GetIcon name="icon-technical-implementation-colored"/><GetIcon name="icon-user-experience-colored"/></div>
                        <h3>Technical Implementation<br/><span>and</span> User Experience</h3>
                      </div>

                      <p className="winner-project">Rescascade team with project Black Box</p>

                      <p className="winner-names">CivilAaron, Artemis-chan, Kireita, aln</p>
                    </div>

                    <div className="winner-image-container">
                      <img className="winner-image" src={previewImageTI}></img>
                    </div>
                  </li>

                  <li className="winner-item">
                    
                    <div className="winner-description winner-description-art">
                      <span className="mobile-none">winner in the nominations</span>

                      <div className="winner-title-wrapper">
                        <div className="winner-icons winner-icons-mt"><GetIcon name="icon-art-colored"/></div>
                        <h3>Art <span>and</span> Audience Choice Award</h3>
                      </div>

                      <p className="winner-project">Krypton team with project BlackBox - Purification of soul</p>

                      <p className="winner-names">MaxStgs, Soulfiber</p>
                    </div>

                    <div className="winner-image-container">
                      <img className="winner-image" src={previewImageArt}></img>
                    </div>
                  </li>
                </ul>
              </div>
            </section>

            <section id="download-community-sdk" className="download-community-sdk">
              <div className="container-wrapper--green500">
                <div className="content-container content-container--download-community-sdk">
                  <p className="text-center">All submissions must be powered by UNIGINE (real-time 3D engine)</p>

                  <a href="https://unigine.com/products/community/advantages/" target="_blank" className="button button--purple">Download UNIGINE 2 Community SDK</a>
                </div>
              </div>
            </section>

            <section id="what-is-hackathon" className="what-is-hackathon">
              <div className="container-wrapper--grey100">
                <div className="content-container">
                  <div className="content-container--text">
                    <h2 className="subtitle">WHAT IS A HACKATHON?</h2>

                    <p>A hackathon is a design sprint-like event, in which computer programmers, graphic designers, interface designers, and others collaborate intensively on software projects.</p>

                    <p>The duration of the Second UNIGINE Community Hackathon (apps creation part) is 79 hours.</p>

                    <p>The goal of a hackathon is to create, by the end of the event, functioning software that complies with the hackathon rules.</p>
                  </div>
                </div>
              </div>
            </section>

            <section id="contacts" className="contact-us">
              <div className="container-wrapper--green500">
                <div className="content-container content-container--contact-us">
                  <div className="content-container--text">
                    <h2 className="subtitle">CONTACT US</h2>

                    <p>To contact us for a question or anything else, <a href="https://discord.gg/gFN7w9b" target="_blank">join our Discord server</a></p>
                  </div>
                </div>
              </div>
            </section>

            <section id="subscribe" className="subscribe-us">
              <div className="container-wrapper--grey900">
                <div className="content-container content-container--subscribe-us">
                  <div className="content-container--text">
                    <h4>Subscribe to UNIGINE updates so you don't miss the next one!</h4>

                    <a href="https://unigine.com/?sign-up-for-news=true#news" target="_blank" className="button button--green">subscribe</a>

                    <p className="center">By subscribing, you agree with the <a href="https://unigine.com/company/legal/policy-privacy" target="_blank">UNIGINE Privacy Policy</a> and the processing and use of your information</p>
                  </div>
                </div>

                <GetIcon name="circles-5-colored"/>
              </div>
            </section>

            {/* <section id="how-to-join" className="how-to-join">
              <div className="container-wrapper--grey900">
                <div className="content-container content-container--how-to-join">
                  <h2 className="subtitle subtitle--center">HOW TO JOIN</h2>

                  <div className="columns">
                    <div className="column">
                      <GetIcon name="step-1-colored"/>
                      <div className="column-text"><a href="https://discord.gg/gFN7w9b" target="_blank">Join our Discord server</a> and write a private message to our <strong>bot @UNIGINE</strong> with your email. The bot will add you to the hackathon participants list - you’ll get a “UNIGINE Hackathon #2” role and see the “UNIGINE Hackathon #2” channels group.</div>
                    </div>

                    <div className="column">
                      <GetIcon name="step-2-colored"/>
                      <div className="column-text">Create a team following the bot’s instructions (you can also read them in the <AnchorLink offset={60} href="#faq">FAQ section below</AnchorLink>)</div>
                    </div>
                  </div>
                </div>
              </div>
            </section> */}

            {/* <section id="schedule" className="schedule">
              <div className="content-container">
                <div className="content-container--text">
                  <h2 className="subtitle">THE HACKATHON SCHEDULE</h2>
                </div>

                <div className="schedule-wrapper">
                  <ul className="schedule-list">
                    <li className="schedule-item">
                      <div className="schedule-number">1</div>

                      <div className="schedule-text-block">
                        <div className="schedule-date-block">
                          <div className="schedule-time">from 16:00 UTC</div>
                          <div className="schedule-date">January <span>28, 2021</span></div>
                          <div className="schedule-weekday">Thursday</div>
                        </div>

                        <div className="schedule-text">Beginning of the hackathon. Watch the <a href="https://youtu.be/GqgBQdBLdTA" target="_blank">Hackathon Opening Stream</a> at 16:00 UTC on Thursday, January 28, 2021 to find out the Hackathon Theme</div>
                      </div>
                    </li>

                    <li className="schedule-item">
                      <div className="schedule-number">2</div>
                      
                      <div className="schedule-text-block">
                        <div className="schedule-date-block">
                          <div className="schedule-time">till 23:00 UTC</div>
                          <div className="schedule-date">January <span>31, 2021</span></div>
                          <div className="schedule-weekday">Sunday</div>
                        </div>

                        <div className="schedule-text">Upload your app <a href="https://itch.io/jam/second-unigine-community-online-hackathon" target="_blank">here</a> till 23:00 UTC on Sunday, January 31, 2021 (your app must meet the <AnchorLink href="#rules" offset={60}>hackathon rules</AnchorLink>)</div>
                      </div>
                    </li>

                    <li className="schedule-item">
                      <div className="schedule-number">3</div>

                      <div className="schedule-text-block">
                        <div className="schedule-text">(optionally) Post a video about your project on YouTube with the hashtag <strong>#uniginehackathon</strong> to better present your project to the Audience Choice Award nomination voters. You can also specify the YouTube-link on the project submission page.</div>
                      </div>
                    </li>

                    <li className="schedule-item">
                      <div className="schedule-number">4</div>

                      <div className="schedule-text-block">
                        <div className="schedule-text">(optionally) Watch the <strong>#uniginehackathon</strong> videos <a href="https://youtube.com/playlist?list=PLgeSUiT3pydENogRA_GwRw7Jkfbw1i6wv" target="_blank">in this playlist</a> and <a href="https://itch.io/jam/second-unigine-community-online-hackathon" target="_blank">submit your vote for the winner</a></div>
                      </div>
                    </li>

                    <li className="schedule-item">
                      <div className="schedule-number">5</div>

                      <div className="schedule-text-block">
                        <div className="schedule-date-block">
                          <div className="schedule-time">16:00 UTC</div>
                          <div className="schedule-date">February <span>7, 2021</span></div>
                          <div className="schedule-weekday">Sunday</div>
                        </div>

                        <div className="schedule-text">Watch the <a href="https://youtu.be/O-bdNcA7C6w" target="_blank">Hackathon Winners Announcement</a></div>
                      </div>
                    </li>

                    <li className="schedule-item">
                      <div className="schedule-number">6</div>

                      <div className="schedule-text-block">
                        <div className="schedule-text">If you have managed to submit an application that complies with the <AnchorLink href="#rules" offset={60}>hackathon rules</AnchorLink> - get your UNIGINE Community Hackathon Participant official PDF-certificate and your prizes if you’re a winner! (we’ll tell how to get the prizes during the <a href="https://youtu.be/O-bdNcA7C6w" target="_blank">Winners Announcement stream</a>)</div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </section> */}

            {/* <section id="timer" className="timer">
              <div className="container-wrapper--grey100">
                <div className="content-container content-container--timer">
                  <div className="content-container--text">
                    <h2 className="subtitle subtitle--center">SUBMIT YOUR VOTE</h2>
                  </div>
                  <p className="center mb10">Submitted your app? Vote for the Audience Choice Award winner!</p>

                  <p className="center">The voting open from 23:00 UTC, January 31, 2021 to 16:00 UTC, February 7, 2021</p>

                  <Countdown date={Date.parse('7 Feb 2021 16:00:00 UTC')} renderer={this.renderer} zeroPadTime={2} />
                  
                  <a href="https://itch.io/jam/second-unigine-community-online-hackathon" className="button button--green">SUBMIT YOUR VOTE</a>
                </div>
              </div>
            </section> */}

            {/* <section className="communication">
              <div className="container-wrapper--grey900">
                <div className="content-container content-container--communication">
                  <div className="content-container--text">
                    <h2 className="subtitle subtitle--center">COMMUNICATION</h2>
                  </div>

                  <div className="content-container--text-wide">
                    <p className="center"><a href="https://discord.gg/gFN7w9b" target="_blank">Join our Discord server</a> to create a team, add new members, join or leave a hackathon team, communicate with other participants before, during, and after the hackathon, and stay up to date on the progress of the event.</p>

                    <p className="center small-text">To follow the hackathon news, join us on</p>
                  </div>

                  <div className="social-container">
                    <ul className="social-list">
                      <li className="social-item">
                        <a className="social-link" target="_blank" href="https://www.youtube.com/unigine_official">
                          <GetIcon name="logo-circled-youtube"/>
                        </a>
                      </li>
                      <li className="social-item">
                        <a className="social-link" target="_blank" href="https://twitter.com/Unigine">
                          <GetIcon name="logo-circled-twitter"/>
                        </a>
                      </li>
                      <li className="social-item">
                        <a className="social-link" target="_blank" href="https://www.facebook.com/Unigine">
                          <GetIcon name="logo-circled-fb"/>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section> */}

            {/* <section id="ranking-and-winners" className="competition-nominations">
              <div className="container-wrapper--green200">
                <div className="content-container content-container--competition-nominations">
                  <div className="content-container--text">
                    <h2 className="subtitle subtitle--center">COMPETITION NOMINATIONS</h2>

                    <p>Ranking and <strong>winners in the four competition nominations + the main winner</strong> are determined by an expert jury. In addition, voting for the <strong>Audience Choice Award</strong> will be conducted (among the hackathon participants only).</p>
                    
                    <p>The expert jury evaluates all participating applications in the four following nominations:</p>

                    <ul className="nomination-list">
                      <li className="nomination-item">
                        <GetIcon name="lamp"/>
                        <div className="nomination-text">idea & narrative</div>
                      </li>

                      <li className="nomination-item">
                        <GetIcon name="tools"/>
                        <div className="nomination-text">technical implementation</div>
                      </li>
                      
                      <li className="nomination-item">
                        <GetIcon name="palette"/>
                        <div className="nomination-text">art</div>
                      </li>
                      
                      <li className="nomination-item">
                        <GetIcon name="like-hand"/>
                        <div className="nomination-text">user experience</div>
                      </li>
                    </ul>
                    <p>As a result, there will be 6 winners:<br/>one Main Winner + four Winners in the Competition Nominations + the Audience Choice Award winner.</p>

                    <p>All “winners” are teams.</p>
                  </div>
                </div>

                <GetIcon name="circles-2-colored"/>
              </div>
            </section> */}

            {/* <section className="prizes">
              <div className="container-wrapper--grey900">
                <div className="content-container content-container--prizes">
                  <div className="content-container--text">
                    <h2 className="subtitle subtitle--center">PRIZES</h2>
                  </div>

                  <div className="prizes-container">
                    <ul className="prizes-list">
                      <li className="prizes-item">
                        <h3 className="prizes-title">Main Winner</h3>
                        <ul>
                          <li>UNIGINE 2 Engineering annual license for each team member</li>
                          <li>Steam Wallet Codes for $100 for each team member</li>
                          <li>Personal consultation of UNIGINE experts (8 hours) on any team project during the year</li>
                          <li>Digital badges in Discord and UNIGINE developer forum</li>
                          <li>Digital Award Certificate for each team member</li>
                        </ul>
                      </li>
                      
                      <li className="prizes-item">
                        <h3 className="prizes-title">Winners in the Competition Nominations</h3>
                        <ul>
                          <li>UNIGINE 2 Community Pro annual license for each team member</li>
                          <li>Steam Wallet Codes for $50 for each team member</li>
                          <li>Digital badges in Discord and UNIGINE developer forum</li>
                          <li>Digital Award Certificate for each team member</li>
                        </ul>
                      </li>
                      
                      <li className="prizes-item">
                        <h3 className="prizes-title">Audience Choice Award</h3>
                        <ul>
                          <li>UNIGINE 2 Community Pro annual license for each team member</li>
                          <li>Steam Wallet Codes for $50 for each team member</li>
                          <li>Digital badges in Discord and UNIGINE developer forum</li>
                          <li>Digital Award Certificate for each team member</li>
                        </ul>
                      </li>
                    </ul>
                  </div>

                  <div className="content-container--text">
                    <p className="disclaimer"><strong>Disclaimer</strong>: Prizes are not cumulative in case of victory in several nominations and/or categories.</p>
                  </div>
                </div>

                <GetIcon name="circles-3-colored"/>
              </div>
            </section> */}

            {/* <section id="juri" className="juri">
              <div className="container-wrapper--grey900">
                <div className="content-container content-container--juri">
                  <div className="content-container--text">
                    <h2 className="subtitle subtitle--center">JURY</h2>

                    <p className="center">The submitted projects will be ranked by the UNIGINE developers team and invited guests</p>
                  </div>
                </div>
              </div>
            </section> */}

            {/* <section id="rules" className="rules">
              <div className="content-container content-container--competition-rules">
                <div className="content-container--text">
                  <h2 className="subtitle">RULES</h2>

                  <ol>
                    <li>The hackathon starts at 16:00 UTC on Thursday, January 28, 2021, with the <a href="https://youtu.be/GqgBQdBLdTA" target="_blank">Hackathon Opening Stream</a> revealing the Hackathon Theme</li>
                    <li>Project submission is open from January 28, 2021, 16:00 UTC to January 31, 2021, 23:00 UTC (hackathon duration is 79 hours)</li>
                    <li>Jury Voting and voting for the Audience Choice Award are open from January 31, 2021, 23:00 UTC to February 07, 2021, 16:00 UTC (voting duration is 163 hours). Ranking and winners in the four competition nominations and the main winner are determined by an expert jury. The Audience Choice Award winner is determined by participants voting. Only teams, who submitted projects during the submission period, can vote for the Audience Choice Award winner project. You can’t vote for your own project.</li>
                    <li>Employees of UNIGINE can participate in the hackathon, but <span>out of competition</span></li>
                    <li>To participate in the competition, the submitted application must meet the following requirements:
                      <ol>
                        <li>The applications to be created on a specific topic - the Hackathon Theme announced at the <a href="https://youtu.be/GqgBQdBLdTA" target="_blank">Hackathon Opening Stream</a></li>
                        <li>Obligatory application features: 3D graphics; made with UNIGINE 2 Community SDK; for Windows, Linux or VR</li>
                        <li>The application should start and not “crash” for at least 5 minutes</li>
                        <li>The applications can be of any type: mini-game, educational application, artwork, etc.</li>
                        <li>UNIGINE demos cannot be used</li>
                        <li>Add-ons can be used</li>
                        <li>You are free to use any third-party tools or code libraries (without violation of the EULAs - either free or legally purchased!)</li>
                        <li>You are free to use any third-party content or assets you previously created (without breaking the licensing agreements!), but in this case, you need to withdraw from the related Competition Nominations when submitting your app</li>
                        <li>Apps to be submitted in the UNIGINE 2.13 SDK browser project format</li>
                      </ol>
                    </li>
                    <li>Winners of the hackathon will be announced during the <a href="https://youtu.be/O-bdNcA7C6w" target="_blank">Hackathon Winners Announcement</a> stream at 16:00 UTC on Sunday, February 7, 2021</li>
                    <li>Prizes and certificates will be sent to the winners and participants within 2 weeks after the Winners Announcement</li>
                  </ol>
                </div>
              </div>
            </section> */}

            {/* <section id="call-to-action" className="call-to-action">
              <div className="container-wrapper--grey900">
                <div className="content-container content-container--call-to-action">
                  <div className="content-container--text">
                    <h2 className="subtitle">REGISTER FOR THE HACKATHON</h2>

                    <ul>
                      <li>1. <a href="https://discord.gg/gFN7w9b" target="_blank">Join our Discord server</a></li>
                      <li>2. Then write a private message to our <strong>bot&nbsp;@UNIGINE</strong> with <strong>your email</strong></li>
                      <li>3. <strong>Create a team</strong> following the bot’s instructions</li>
                    </ul>
                  </div>
                </div>
              </div>
            </section> */}

            {/* <section id="faq" className="faq">
              <div className="content-container content-container--faq">
                <div className="content-container--text">
                  <h2 className="subtitle">FAQ</h2>
                </div>

                <ul className="faq-list">
                  <li className="faq-item">
                    <div className="faq-head" onClick={this.clickSpoilerHandler}>Where do I find the UNIGINE developer documentation?</div>
                    <div className="faq-body">It’s <a href="https://developer.unigine.com/en/docs" target="_blank">here</a></div>
                  </li>

                  <li className="faq-item">
                    <div className="faq-head" onClick={this.clickSpoilerHandler}>How to get the UNIGINE hackathon member role on Discord?</div>
                    <div className="faq-body">
                      <ol>
                        <li>Join our <a href="https://discord.gg/gFN7w9b" target="_blank">Discord server</a></li>
                        <li>On Discord, write a private message to our bot @UNIGINE  - in the text of the message mention your email.</li>
                        <li>The bot will add you to the hackathon participants list - you’ll get the “UNIGINE Hackathon #2” role and see the “UNIGINE Hackathon #2” channels group.</li>
                        <li>Your nickname on Discord after getting the “UNIGINE Hackathon #2” role will become blue.</li>
                      </ol>
                    </div>
                  </li>
                  
                  <li className="faq-item">
                    <div className="faq-head" onClick={this.clickSpoilerHandler}>How to create a new team?</div>
                    <div className="faq-body">
                      <ol>
                        <li>Make sure you have the “UNIGINE Hackathon #2” role on Discord (instruction above)</li>
                        <li>If you have got the “UNIGINE Hackathon #2” role, on Discord, go to the <strong>#hackathon-bot</strong> channel to give commands to the bot @UNIGINE regarding the hackathon (it’s the only channel to give the bot @UNIGINE commands regarding the hackathon)</li>
                        <li>Write <strong>!team &lt;name&gt;</strong> to create a new team named "name"
                          <ul>
                            <li>If you are already a member of another team - you can’t create a new one. Leave the previous team before founding a new one</li>
                            <li>A team name can be up to 25 characters long</li>
                            <li>Only Latin characters, numbers, and spaces are allowed in the team name</li>
                            <li>If a team with the same name already exists, you’ll need to choose another name</li>
                            <li>If all is well, the bot @UNIGINE creates a new team with the prefix Team</li>
                          </ul>
                          </li>
                        <li>After creating the team you will get one more role “Team &lt;name&gt;” (it means, that you are a member of the Team &lt;name&gt;) and lose the role “Looking for team” if you had it</li>
                        <li>Two private channels will be created for your team: a text channel + a voice channel</li>
                      </ol>
                    </div>
                  </li>
                  
                  <li className="faq-item">
                    <div className="faq-head" onClick={this.clickSpoilerHandler}>How to add members to my team?</div>
                    <div className="faq-body">
                      <ol>
                        <li>On Discord, go to the <strong>#hackathon-bot</strong> channel to give commands to the bot @UNIGINE regarding the hackathon (it’s the only channel to give the bot @UNIGINE commands regarding the hackathon)</li>
                        <li>Write <strong>!add &lt;@nick&gt;</strong> to add to your team a new team member with a nickname on Discord “@nick”
                          <ul>
                            <li>you can add members only to a team you are a member of</li>
                            <li>you can’t add to a team several users at a time</li>
                            <li>you can’t add to a team yourself or bots</li>
                            <li>a user that you are adding must have the “UNIGINE Hackathon #2” role</li>
                            <li>the user that you are adding must not be a member of another team</li>
                          </ul>
                        </li>
                        <li>After adding a new team member to your team the new team member gets the “Team &lt;name&gt;” role dedicated to your team and loses the role “Looking for team” if he/she had it</li>
                        <li>The two private channels of your team (a text channel + a voice channel) are now available for your new team member</li>
                      </ol>
                    </div>
                  </li>
                  
                  <li className="faq-item">
                    <div className="faq-head" onClick={this.clickSpoilerHandler}>How to leave the team you are a member of?</div>
                    <div className="faq-body">
                      <ol>
                        <li>On Discord, go to the <strong>#hackathon-bot</strong> channel to give commands to the bot @UNIGINE regarding the hackathon (it’s the only channel to give the bot @UNIGINE commands regarding the hackathon)</li>
                        <li>Write !leave to leave a team you are a member of
                          <ul>
                            <li>you can only leave a team if you were a member of a team</li>
                          </ul>
                        </li>
                        <li>After leaving your team you will lose the Team &lt;name&gt; role</li>
                        <li>You won’t see the private channels of your ex-team anymore</li>
                        <li>If there are no more members in the team, the team will be deleted</li>
                      </ol>
                    </div>
                  </li>
                  
                  <li className="faq-item">
                    <div className="faq-head" onClick={this.clickSpoilerHandler}>How to join an existing team?</div>
                    <div className="faq-body">
                      <ol>
                        <li>Make sure you have the “UNIGINE Hackathon #2” role on Discord (instruction above)</li>
                        <li>Make sure you are not a member of another UNIGINE hackathon team. If you are already a member of another team - you can’t join a second one. Leave the previous team before joining a new one (instruction above)</li>
                        <li>Write a private message to a team member of the team you want to join, and ask them to add you to the team (instruction above)</li>
                        <li>After joining a team you will lose the role “Looking for team” if you had it</li>
                        <li>After joining the team two private team channels will be available for you: a text channel + a voice channel</li>
                      </ol>
                    </div>
                  </li>
                  
                  <li className="faq-item">
                    <div className="faq-head" onClick={this.clickSpoilerHandler}>How to indicate that you are looking for a team to join?</div>
                    <div className="faq-body">
                      <ol>
                        <li>Make sure you have the “UNIGINE Hackathon #2” role on Discord (instruction above)</li>
                        <li>Make sure you are not a member of another UNIGINE hackathon team. If you are already a member of another team - you can’t indicate that you are looking for a team. Leave the previous team before looking for a new one</li>
                        <li>On Discord, go to the #role-assignment channel and react to the welcome message with the (:wave:) emoticon. You will get the “Looking for team” role.</li>
                        <li>To lose the “Looking for team” role - remove your (:wave:) reaction to the message in the #role-assignment channel, or found your own team (instruction above), or join an existing team (instructions above)</li>
                        <li>After getting a “Looking for team” role, you’ll be added to the list “Looking for team” and highlighted among other hackathon members - your nickname on Discord will be colored yellow. After losing this role, your nickname will turn blue again.</li>
                        <li>To find a team faster, do not neglect networking on the #looking-for-team channel</li>
                      </ol>
                    </div>
                  </li>
                  
                  <li className="faq-item">
                    <div className="faq-head" onClick={this.clickSpoilerHandler}>How to find people who are looking for a team to join?</div>
                    <div className="faq-body">
                      <ol>
                        <li>The UNIGINE hackathon members with the role “Looking for team” are displayed in a separate list in the right Discord menu. They are also highlighted among other hackathon members by the yellow-colored nicknames.</li>
                        <li>Contact the “Looking for team” members via private messages or write to them all using the @looking-for-team alias (but please don’t “spam” every 10 mins ;)</li>
                        <li>After finding your ideal teammate, add him/her to your team as a new member (instruction above)</li>
                      </ol>
                    </div>
                  </li>
                  
                  <li className="faq-item">
                    <div className="faq-head" onClick={this.clickSpoilerHandler}>How to exclude a team member from your UNIGINE hackathon team?</div>
                    <div className="faq-body">
                      <ol>
                        <li>If you don’t want to keep going on with some team members - ask them to leave your team. They have to write the <strong>!leave</strong> command on the <strong>#hackathon-bot</strong> channel by themselves.</li>
                        <li>If they are missing and do not respond - turn to the UNIGINE server admins.</li>
                      </ol>
                    </div>
                  </li>
                  
                  <li className="faq-item">
                    <div className="faq-head" onClick={this.clickSpoilerHandler}>How to submit a project?</div>
                    <div className="faq-body">
                      <ol>
                        <li>Go to <a href="https://itch.io/jam/second-unigine-community-online-hackathon" target="_blank">this page</a></li>
                        <li>Press the button “Submit your project”</li>
                        <li>Follow the instructions</li>
                      </ol>
                    </div>
                  </li>
                  
                  <li className="faq-item">
                    <div className="faq-head" onClick={this.clickSpoilerHandler}>How to participate in the Audience Choice Award?</div>
                    <div className="faq-body">
                      <ol>
                        <li>Post a video or stream about your project on YouTube with the hashtag <strong>#uniginehackathon</strong> before the voting period ends.</li>
                        <li>You can optionally specify the link to your <strong>#uniginehackathon</strong> video on YouTube in the project submission form.</li>
                      </ol>
                    </div>
                  </li>
                  
                  <li className="faq-item">
                    <div className="faq-head" onClick={this.clickSpoilerHandler}>Are there any limitations on the team size?</div>
                    <div className="faq-body">
                      The maximum team size is 10 people.
                    </div>
                  </li>
                  
                  <li className="faq-item">
                    <div className="faq-head" onClick={this.clickSpoilerHandler}>How to vote for the Audience Choice Award winner?</div>
                    <div className="faq-body">
                      <ol>
                        <li><strong>Only teams, who submitted projects during the submission period, can vote for the Audience Choice Award winner project.</strong></li>
                        <li>You can’t vote for your own project</li>
                        <li>(Optionally) To choose a project you like most, watch the project videos in the <a href="https://youtube.com/playlist?list=PLgeSUiT3pydENogRA_GwRw7Jkfbw1i6wv" target="_blank">Hackathon playlist</a>. New videos may be added to the playlist during the whole time of submission and voting periods.</li>
                        <li>Сast your vote for the winner <a href="https://itch.io/jam/second-unigine-community-online-hackathon" target="_blank">here</a>. The voting is open only during the voting period.</li>
                      </ol>
                    </div>
                  </li>
                </ul>
              </div>
            </section> */}

            <section id="who-is-unigine" className="who-is-unigine">
              <div className="container-wrapper--gradient-purple">
                <div className="content-container content-container--who-is-unigine">
                  <div className="content-container--text">
                    <h2 className="subtitle">WHO IS UNIGINE</h2>

                    <p>Established in 2005, UNIGINE is a global company focused on real-time 3D technologies, delivering powerful B2B and B2C solutions for simulation, visualization, scientific research, video games, virtual reality systems, and more. UNIGINE has received worldwide acclaim for developing its proprietary 3D visualization system.</p>

                    <p>UNIGINE 2 is a real-time 3D engine packed together with C++/C# API, and visual tools for the creation of high-end games and interactive applications. The distinguishing features of UNIGINE are handling of the very large virtual worlds, outstanding performance on complex 3D scenes, and a rich set of modules available right out of the box. UNIGINE Engine is a universal framework for aerospace / land / maritime scenarios. It is used in both enterprise (professional simulators, GIS and smart city apps, digital twins in 3D), and entertainment areas (games, video production). More than 250 companies around the world are the customers of UNIGINE. UNIGINE engine also is a core of popular GPU benchmarks series (including Heaven and Superposition).</p>

                    <p>To support creative endeavors of individual enthusiasts and small projects, scientists, students, and non-profit organizations from all over the world, UNIGINE recently released the free Community edition of the SDK that is already in use by tens of thousands of technology enthusiasts, especially game developers.</p>

                    <p>We are pleased to invite you to participate in our Second UNIGINE Community Online Hackathon.</p>

                    <p>Enjoy the competition!</p>
                  </div>

                  <div className="iframe-container">
                    <iframe className="iframe" width="1169" height="657" src="https://www.youtube.com/embed/1n3jNl_1HNM" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                  </div>
                </div>
              </div>
            </section>
          </main>
          <Footer/>

          <ScrollUpButton
            ContainerClassName='scroll-up-button'
          />
        </Fragment>
    );
  }
}

export default withRouter(LayoutMain);
